import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

import { onUpdated, reactive } from "vue";
import Multiselect from "@vueform/multiselect";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputSelectSearch',
  props: {
  modelValue: {
    type: [String, Number],
    required: false,
    default: "",
  },
  fetchOptions: {
    type: Function,
    required: true,
  },
  valorInicial: {
    type: Object,
  },
  label: String,
  required: Boolean,
  disabled: Boolean,
  placeholder: String,
},
  emits: ["changeNome", "update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const onInput = (event: { value: number; label: string }) => {
  emit("update:modelValue", event?.value || undefined);
  emit("changeNome", event?.label || undefined);
};

onUpdated(async () => {
  if (props?.valorInicial?.value) {
    data.valorInicial.value = props?.valorInicial?.value;
    data.valorInicial.label = props?.valorInicial?.label;
  }
});

const data = reactive({
  valorInicial: { value: undefined, label: undefined },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass({ required: props.required })
        }, _toDisplayString(props.label), 3))
      : _createCommentVNode("", true),
    _createVNode(_unref(Multiselect), {
      onChange: onInput,
      modelValue: data.valorInicial,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.valorInicial) = $event)),
      mode: "single",
      disabled: props.disabled,
      caret: false,
      closeOnSelect: true,
      searchable: true,
      filterResults: false,
      minChars: 2,
      resolveOnLoad: false,
      required: props.required,
      object: true,
      delay: 300,
      placeholder: props.placeholder || 'Selecione uma das Opções',
      noOptionsText: "Digite para buscar",
      noResultsText: "Nenhuma opção encontrada",
      options: 
        async function (query) {
          return await props.fetchOptions(query);
        }
      
    }, null, 8, ["modelValue", "disabled", "required", "placeholder", "options"])
  ]))
}
}

})